import offerTypes from "astrid-firestore/src/api/offers/constants/offerTypes";

const offerTypeIcons = {
	[offerTypes.OPEN]: "hand paper",
	[offerTypes.WORK_ORDER]: "paper plane",
	[offerTypes.INQUIRY]: "question",
};

export default offerTypeIcons;
